import React, { useEffect, useState } from 'react';

export default function LoadingScreen({ onComplete }) {
  const [progress, setProgress] = useState(0);
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const duration = 2000; // 2 seconds
    const interval = 20; // Update every 20ms
    const steps = duration / interval;
    let currentStep = 0;

    const timer = setInterval(() => {
      currentStep++;
      setProgress((currentStep / steps) * 100);
      
      if (currentStep >= steps) {
        clearInterval(timer);
        setTimeout(() => {
          setIsVisible(false);
          onComplete?.();
        }, 300);
      }
    }, interval);

    return () => clearInterval(timer);
  }, [onComplete]);

  if (!isVisible) return null;

  return (
    <div 
      className="loading-screen"
      style={{
        opacity: progress >= 100 ? 0 : 1,
        transition: 'opacity 0.5s ease-out'
      }}
      data-testid="loading-screen"
    >
      {/* Logo */}
      <div className="text-center mb-8">
        <h1 className="font-orbitron text-3xl sm:text-4xl font-black text-white uppercase tracking-widest">
          Doon
        </h1>
        <h2 className="font-orbitron text-xl sm:text-2xl font-bold text-cyan-400 uppercase tracking-widest">
          Auto Glass
        </h2>
      </div>
      
      {/* Loading bar */}
      <div className="loading-bar">
        <div 
          className="loading-bar-fill"
          style={{ width: `${progress}%` }}
        ></div>
      </div>
      
      {/* Loading text */}
      <p className="text-gray-500 text-sm mt-4 font-orbitron tracking-wider">
        Loading {Math.round(progress)}%
      </p>
      
      {/* Decorative elements */}
      <div className="absolute top-1/4 left-1/4 w-32 h-32 bg-cyan-500/5 rounded-full blur-2xl"></div>
      <div className="absolute bottom-1/4 right-1/4 w-40 h-40 bg-blue-500/5 rounded-full blur-2xl"></div>
    </div>
  );
}
